import React, { FC } from 'react';
import { ACCESS_AUTHENTICATED } from '../../../../services/route/permissions';
import AuthCheck from '../../../helpers/AuthCheck/AuthCheck';
import SheetLayout from '../../../layouts/SheetLayout/SheetLayout';
import SignalActivateContainer from '../containers/SignalActivateContainer/SignalActivateContainer';

const SignalHomePage: FC = () => (
  <SheetLayout
    showMenuBar={false}
    showMapOverlay
    heading="Signal"
    slideUpTransition
  >
    <AuthCheck authentication={ACCESS_AUTHENTICATED}>
      <SignalActivateContainer />
    </AuthCheck>
  </SheetLayout>
);

export default SignalHomePage;
